<custom-modal [header]="headerKey" [open]="isOpen" [modalClass]="'delete-company-modal'" (openChange)="onCancel()">
  <div [innerHTML]="descriptionKey | translate : { companyName: displayName }"></div>

  <button footer-action type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isDeleting">
    {{ "BUTTON.DISCARD" | translate }}
  </button>
  <button footer-action type="button" class="btn btn-primary ml-2" (click)="onConfirm()" [disabled]="isDeleting">
    <span *ngIf="isDeleting" class="fa fa-spinner fa-spin mr-1"></span>
    {{ confirmButtonKey | translate }}
  </button>
</custom-modal>
